import { EventEmitter, Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FuseSplashScreenService } from "@barebone-fuse/@fuse/services/splash-screen.service";
import { CommandService } from "@core/services/command.service";
import { SnackBarService } from "@core/services/snack-bar.service";
import { PlatformCommand } from "@shared/commands/command-base";
import { IPlatformCommandHandler, IPlatformToolHandler } from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import { InvalidateSubject } from "@shared/helpers/invalidate.subject";
import { MagicLinkModel, TabModel } from "@shared/models/platform-tool-models";
import { Subject, take } from "rxjs";



@Injectable({
  providedIn: 'root',
})
export class PlatformToolSystemWorkflowSettingsHandler implements IPlatformToolHandler {
    magicLinkModel: MagicLinkModel;
    ngUnsubscribe = new Subject<void>();
    magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
    invalidateSubject: InvalidateSubject;
    activatedRoute?: ActivatedRoute;
    metaData?: any;
    constructor(private commandService: CommandService,
      private fuseSplashScreenService: FuseSplashScreenService,
      private snackBarService: SnackBarService,
    ) {
      if (!this.invalidateSubject) {
        this.invalidateSubject = new InvalidateSubject();
      }
    }



    valueChanged($event: any) {

      if($event.action){
        const command = $event.dialogField.fieldValues[$event.action.id];
      if (command) {
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandToApi(command);
        return;
      }
      }

      if ($event.fieldDefinition && $event.fieldDefinition.key) {
        const command = $event.dialogField.fieldValues[$event.fieldDefinition.key];
        if(command){
          command.fieldValues['ItemId'] = $event.item.id;
         this.executeCommandToApi(command);
        }
      }
    }
    setSelectedTab(selectedTab: TabModel): void {
    }

    selectionChanged?($event: any): void {
    }
    onFieldSectionChanged?($event: any): void {
    }
    onFieldSectionIndexChanged?($event: any): void {
    }
    onBeforeLoad?(): void {
    }
    destroy(): void {
      this.invalidateSubject.close();
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }

    executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
      return true;

    }

    private executeCommandToApi(command: PlatformCommand) {
      if (command.api && command.api.length > 0 && !command.isDisabled) {
        this.fuseSplashScreenService.show();
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }
          this.invalidateSubject.invalidate();
        },
          error => {
            this.fuseSplashScreenService.hide();
          });
      }
    }



}